import * as React from "react";
const SvgFiRrComplianceClipboard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-compliance-clipboard_svg__a)">
      <path
        fill="#062147"
        d="m21.944 11.478-2.501-.829a3.03 3.03 0 0 0-1.888 0l-2.5.829a3 3 0 0 0-2.056 2.848v3.187c0 3.568 3.714 5.703 4.853 6.272 0 0 .201.206.648.206s.582-.156.582-.156c1.154-.464 4.917-2.291 4.917-6.322v-3.187a3 3 0 0 0-2.055-2.848M22 17.513c0 2.582-2.424 3.925-3.455 4.378C17.629 21.4 15 19.792 15 17.513v-3.187c0-.432.275-.813.686-.949l2.499-.829c.205-.067.428-.067.63 0l2.5.829a1 1 0 0 1 .686.949zM13 9H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2m-2 3a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h5a1 1 0 0 1 1 1m0 4a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h5a1 1 0 0 1 1 1m2 7a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5V7c0-2.757 2.243-5 5-5h.171A3.01 3.01 0 0 1 8 0h2c1.304 0 2.416.836 2.829 2H13c2.757 0 5 2.243 5 5v1a1 1 0 0 1-2 0V7c0-1.654-1.346-3-3-3h-1a1 1 0 0 1-1-1c0-.552-.449-1-1-1H8c-.551 0-1 .449-1 1s-.448 1-1 1H5C3.346 4 2 5.346 2 7v12c0 1.654 1.346 3 3 3h7a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-compliance-clipboard_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrComplianceClipboard;
